/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMenuModal = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 5v14H2V5zm-2 2H4v10h16zM8 13v2H6v-2zm10 0v2h-8v-2zM8 9v2H6V9zm10 0v2h-8V9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMenuModal as MenuModal };
